__turbopack_context__.v({
  "dateCollapsed": "TrackingEvents-module__rv6CCG__dateCollapsed",
  "dateExpanded": "TrackingEvents-module__rv6CCG__dateExpanded",
  "dateLocationCollapsed": "TrackingEvents-module__rv6CCG__dateLocationCollapsed",
  "dateLocationExpanded": "TrackingEvents-module__rv6CCG__dateLocationExpanded",
  "orderedList": "TrackingEvents-module__rv6CCG__orderedList",
  "orderedlistItem": "TrackingEvents-module__rv6CCG__orderedlistItem",
});
